<template>
  <b-modal
    id="view-image-modal"
    hide-footer
    hide-header
    centered
    dialog-class="!p-0"
    body-class="!p-0"
  >
    <b-img
      :src="img"
      class="w-full"
      alt="image variant product"
    />
  </b-modal>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default: null,
    },
  },
}
</script>
